import React, { useState, useEffect} from 'react';
import { motion } from 'framer-motion';
import ReactTolltip from "react-tooltip"
import { images } from '../../constants';
import { AppWrap, MotionWrap } from '../../wrapper';
import './Skills.scss';
import ReactTooltip from 'react-tooltip';

const Skills = () => {


  const [skills, setSkills] = useState([
    {
      "title": "NodeJS",
      "name": "NodeJS",
      "icon": images.node,
      "bgColor": "white",
      "description": "talking about my skill",
    },
    {
      "title": "ReactJS",
      "name": "ReactJS",
      "icon": images.react,
      "bgColor": "white",
      "description": "talking about my skill",
    },

    {
      "title": "Git",
      "name": "Git",
      "icon": images.git,
      "bgColor": "white",
      "description": "talking about my skill",
    },

    {
      "title": "MaterialUI",
      "name": "MaterialUI",
      "icon": images.mu5,
      "bgColor": "white",
      "description": "talking about my skill",
    },

    {
      "title": "HTML",
      "name": "HTML",
      "icon": images.html,
      "bgColor": "white",
      "description": "talking about my skill",
    },

    {
      "title": "CSS",
      "name": "CSS",
      "icon": images.css,
      "bgColor": "white",
      "description": "talking about my skill",
    },

    {
      "title": "JavaScript",
      "name": "JavaScript",
      "icon": images.javascript,
      "bgColor": "white",
      "description": "talking about my skill",
    },

    {
      "title": "SASS",
      "name": "SASS",
      "icon": images.sass,
      "bgColor": "white",
      "description": "talking about my skill",
    },

    {
      "title": "API",
      "name": "API",
      "icon": images.api,
      "bgColor": "white",
      "description": "talking about my skill",
    },

    {
      "title": "Java",
      "name": "Java",
      "icon": images.java,
      "bgColor": "white",
      "description": "talking about my skill",
    },

    {
      "title": "Bootstrap",
      "name": "Bootstrap",
      "icon": images.bootstrap,
      "bgColor": "white",
      "description": "talking about my skill",
    },

  ])



  const [experience, setExperience] = useState([
    {
      "name": "Online Team Member",
      "company": "Woolworths",
      "year": "Aug 2021 - Mar 2022",
      "imgURL": images.about03,
      "description": "I worked as an online team member where i was responsible for ensuring the collection and packing of online orders made from my assigned store",
      "brief": "I worked as an online team member where i was responsible for ensuring the collection ..."
    },
    {
      "name": "Web Developer",
      "company": "Cloudsense",
      "year": "Feb 2020 - Nov 2020",
      "imgURL": images.about03,
      "description": "I Worked as a web developer to create a webpack plugin capable of detecting security threats in web based components on the salesforce platform",
      "brief": "I Worked as a web developer to create a webpack plugin..."
    },

    
  ])





  return (

    <>
      <h2 className='title-text'>Skills & Experience</h2>

      <div className='app__skills-container'>
        <motion.div className='app__skills-list'>
          {skills.map((skill) => (
            <motion.div
              whileInView={{opacity: [0,1]}}
              transition={{ duration: 0.5 }}
              className="app__skills-item app__flex"
              key={skill.name}
            >
              <div className='app__flex' style={{backgroundColor: skill.bgColor}}>
                <img src={skill.icon} alt={skill.name} />
              </div>

              <p className='skill-name-text'>{skill.name}</p>

            </motion.div>
          ))}
        </motion.div>



        <motion.div
        className='app__skills-exp'
        >
        {experience.map((experience) => (
         
          <>

          <motion.div
           
            whileHover={{scale:1.1}}
          >
      
            <motion.div
                className="app__skills-exp-item"
                key={experience.year}
              >
              <div className='app__skills-exp-year skillDate'>
                <p className='bold-text'>{experience.year}</p>
              </div>


            <motion.div className="app__skills-exp-works"
            >
                <motion.div
                  whileInView={{opacity: [0,1]}}
                  transition={{ duration: 0.5 }}
                  className="app__skills-exp-work"
                  data-tip
                  data-for = {experience.name}
                  key={experience.name}
                >
                  <h4 className='work-title'>{experience.name}</h4>
                  <p className='p-text'>{experience.company}</p>
                  <p className='p-text'>{experience.description}</p>


              </motion.div>
            </motion.div>

          </motion.div>
          </motion.div>

          </>
          

        ))}
         
        </motion.div>

      </div>
    </>
  )
}

//export default Skills

//export default AppWrap(Skills, 'skills')

export default AppWrap(
  MotionWrap(Skills, 'app__skills'), 
  'skills',
  "app__whitebg"
  );



  //old tool tip code
  // <ReactTooltip
  // id={experience.name}
  // effect="solid"
  // arrowColor='#fff'
  // className='skills-tooltip'
  // >
  // {experience.description}
  // </ReactTooltip>